<template>
  <img :src="watermarkImage" class="page-watermark" alt="Watermark" />
</template>

<script>
export default {
  name: "CompanyWatermark",
  computed: {
    watermarkImage() {
      const companyId = this.$session.get('companyId');
      const extensions = ["png", "jpg", "jpeg"]; // allowed formats

      // Check only inside company folder
      for (const ext of extensions) {
        try {
          return require(`@/assets/images/company${companyId}/watermark.${ext}`);
        } catch (e) {
          // continue trying next extension
        }
      }

      // No watermark exists → return null (so nothing will be shown)
      return null;
    }
  }
}
</script>

<style scoped>

</style>
